import TabRealisasiBahan from './TabRealisasiBahan';

export default TabRealisasiBahan;
